import React from 'react';
import { useForm } from '../../hooks/useForm';
import { CheckoutForm as CheckoutFormType } from '../../types';

interface CheckoutFormProps {
  onSubmit?: (data: CheckoutFormType) => void;
}

export default function CheckoutForm({ onSubmit }: CheckoutFormProps) {
  const { values, handleChange, handleSubmit } = useForm<CheckoutFormType>({
    email: '',
    firstName: '',
    lastName: '',
    title: '',
    company: '',
    companyAddress: '',
    phone: '',
    website: '',
    acceptTerms: false,
    acceptPrivacy: false,
    acceptConsent: false
  });

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit?.(values);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
      <h2 className="text-xl font-semibold mb-6">Contact Information</h2>
      
      <form onSubmit={handleFormSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email Address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
              First Name
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={values.firstName}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
              required
            />
          </div>
          <div>
            <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
              Last Name
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={values.lastName}
              onChange={handleChange}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
              required
            />
          </div>
        </div>

        <div>
          <label htmlFor="title" className="block text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            type="text"
            id="title"
            name="title"
            value={values.title}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
            required
          />
        </div>

        <div>
          <label htmlFor="company" className="block text-sm font-medium text-gray-700">
            Company Name
          </label>
          <input
            type="text"
            id="company"
            name="company"
            value={values.company}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
            required
          />
        </div>

        <div>
          <label htmlFor="companyAddress" className="block text-sm font-medium text-gray-700">
            Company Address
          </label>
          <input
            type="text"
            id="companyAddress"
            name="companyAddress"
            value={values.companyAddress}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
            required
          />
        </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
            Phone Number
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={values.phone}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
            required
          />
        </div>

        <div>
          <label htmlFor="website" className="block text-sm font-medium text-gray-700">
            Company Website
          </label>
          <input
            type="url"
            id="website"
            name="website"
            value={values.website}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-brand-primary focus:ring-brand-primary"
            placeholder="https://"
            required
          />
        </div>

        <div className="space-y-2">
          <label className="flex items-start space-x-2">
            <input
              type="checkbox"
              name="acceptTerms"
              checked={values.acceptTerms}
              onChange={handleChange}
              className="mt-1 rounded border-gray-300 text-brand-primary focus:ring-brand-primary"
              required
            />
            <span className="text-sm text-gray-700">
              I accept the <a href="/terms" className="text-brand-primary hover:text-brand-dark">Terms of Service</a>
            </span>
          </label>

          <label className="flex items-start space-x-2">
            <input
              type="checkbox"
              name="acceptPrivacy"
              checked={values.acceptPrivacy}
              onChange={handleChange}
              className="mt-1 rounded border-gray-300 text-brand-primary focus:ring-brand-primary"
              required
            />
            <span className="text-sm text-gray-700">
              I accept the <a href="/privacy" className="text-brand-primary hover:text-brand-dark">Privacy Policy</a>
            </span>
          </label>

          <label className="flex items-start space-x-2">
            <input
              type="checkbox"
              name="acceptConsent"
              checked={values.acceptConsent}
              onChange={handleChange}
              className="mt-1 rounded border-gray-300 text-brand-primary focus:ring-brand-primary"
              required
            />
            <span className="text-sm text-gray-700">
              I consent to the collection and processing of my personal information as outlined in the privacy policy.
            </span>
          </label>
        </div>
      </form>
    </div>
  );
}